import React from 'react'
import noImage from 'src/assets/images/noimage.png'
import { useSelector } from 'react-redux';
import liveAuth from 'src/helper/liveAuth';
import { NonLoginSignInButton } from 'src/reusable/global';
import { useProductInventoryStore } from 'src/hooks/productInventory';
import NavigateToPDP from 'src/component/Global/Product/NavigateToPDP';

const PDPBestSellingProduct = () => {
    const productDetail = useSelector((state) => state.entities.model_ProductDetail.setProductDetail.data)
    const [{ inventoryList }, { }, { }] = useProductInventoryStore();
    let { TopProducts } = productDetail?.value;

    const getInventory = (ERPPartNumber) => {
        if (inventoryList[ERPPartNumber] !== undefined) {
            return inventoryList[ERPPartNumber];
        }
        return {
            qas: 0,
            quantity: 0
        };
    };

    return (
        <>
            {TopProducts && TopProducts.length > 0 &&
                <div className='best-selling-product'>
                    <h4 className="mb-3 mt-0"> Best Selling Products</h4>
                    <div className='bs5 row d-flex align-items-stretch'>
                        {TopProducts.map((prod, index) => (
                            <div className='col-md-3 mb-3' key={index}>
                                <div className='best-selling-pro-box'>
                                    <div className='best-selling-img text-center mb-3'>
                                        <img src={prod.ThumbnailPath ? prod.ThumbnailPath : noImage} className="" />
                                    </div>
                                    <div className='best-selling-info'>
                                        <NavigateToPDP data={{
                                                    ManufacturerName: prod?.ManufacturerName,
                                                    ERPMFRPartNumber: prod?.ERPMFRPartNumber,
                                                    ItemNumber: prod?.ItemNumber,
                                                }} >
                                            <div className='text-darkgreen font-14 font-arial'><b>{prod?.ERPMFRPartNumber}</b> </div>
                                        </NavigateToPDP>

                                        <p className='mb-0'><i>by {prod?.ManufacturerName}</i> </p>
                                        <p className='mt-0 mb-3 prod-desc'>{prod?.ShortDescription}</p>
                                        <table className='best-selling-table w-100 mb-3'>
                                            <thead>
                                                <tr>
                                                    <td>Stock</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>{getInventory(prod?.ERPPartNumber)?.qas} <i className="fa fa-check-circle text-green"></i></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        {liveAuth.check() ?
                                            <>
                                                <NavigateToPDP data={{
                                                    ManufacturerName: prod?.ManufacturerName,
                                                    ERPMFRPartNumber: prod?.ERPMFRPartNumber,
                                                    ItemNumber: prod?.ItemNumber,
                                                }}>
                                                    <button className="bs5 btn btn-primary w-100">Buy</button>
                                                </NavigateToPDP>
                                            </> : <><NonLoginSignInButton best_selling={true} /> </>
                                        }


                                    </div>
                                </div>
                            </div>
                        ))}


                    </div>
                </div>
            }
        </>
    )
}


export default PDPBestSellingProduct
